import React from 'react';
import { Progress } from 'antd';

import './index.less';

import { getTranslateFunc } from '../../utils/stringUtil';
import IbTooltip from '../common/IbTooltip';
import IbIcon from '../common/IbIcon';
import IbTypography from '../common/IbTypography';

import { MAIN_CLASS_NAME, PERCENT_CLASS_NAME, RING_SIZE, RING_STROKE_WIDTH, TRANSLATION_GROUP_PREFIX } from './const';
import { formatContextTokens, getViewData } from './utils';

export interface IContextWindowUsage {
  usedTokens?: number;
  limit?: number | null;
}

export interface IContextWindowIndicatorProps {
  contextWindow?: IContextWindowUsage;
}

const ContextWindowIndicator: React.FC<IContextWindowIndicatorProps> = ({ contextWindow }) => {
  const translate = getTranslateFunc(TRANSLATION_GROUP_PREFIX);

  const { usedTokens, limit } = contextWindow ?? {};
  if (usedTokens === undefined || !limit) {
    return null;
  }

  const thousandsSuffix = translate('Thousands suffix');
  const { percent, rowModifier, isFull } = getViewData(usedTokens, limit);

  const tooltip = translate('Tooltip', {
    used: formatContextTokens(usedTokens, thousandsSuffix),
    total: formatContextTokens(limit, thousandsSuffix),
  });

  return (
    <IbTooltip className={`${MAIN_CLASS_NAME} ${rowModifier}`} title={tooltip}>
      {isFull ? (
        <IbIcon iconName="attention" size={RING_SIZE} />
      ) : (
        <Progress percent={percent} showInfo={false} strokeWidth={RING_STROKE_WIDTH} type="circle" width={RING_SIZE} />
      )}
      <IbTypography.Paragraph className={PERCENT_CLASS_NAME} type="descriptor">
        {percent}%
      </IbTypography.Paragraph>
    </IbTooltip>
  );
};

export default ContextWindowIndicator;
